import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const userParamsSchema = object({
  userId: stringToNumber()
})
